import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setBreadcrumbs = createAsyncThunk(
  "setBreadcrumbs",
  async (breadcrumbs, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(breadcrumbs);
  }
);

const breadcrumbSlice = createSlice({
  name: "Breadcrumb",
  initialState: {
    breadcrumbs: [],
  },
  extraReducers: (builder) => {
    builder.addCase(setBreadcrumbs.fulfilled, (state, action) => {
      return (state = {
        ...state,
        breadcrumbs: action.payload,
      });
    });
  },
});

export default breadcrumbSlice.reducer;
